export enum DialogKeys {
    NotTestedWarningTestResult = 'notTestedWarningTestResult',
    NotTestedWarningMathwallResults = 'notTestedWarningMathwallResults',
    NotTestedWarningMathwallResults2 = 'notTestedWarningMathwallResults2',
    NotPracticedWarningMathwallResults = 'notPracticedWarningMathwallResults',
    NotTestedWarningDetailsContent = 'notTestedWarningDetailsContent',
    ShortProgrammeAreYouSureAdd = 'shortProgrammeAreYouSureAdd',
    KitchenSinkExample = 'kitchenSinkExample',
    ContentPlayer = 'ContentPlayer',
    Logout = 'Logout',
    Pause = 'Pause',
    StopLongProgramme = 'stopLongProgramme',
    StopShortProgramme = 'stopShortProgramme',
    ClosePaperTestResults = 'closePaperTestResults',
    SavePaperTestResults = 'savePaperTestResults',
    SaveAndFinishPaperTest = 'saveAndFinishPaperTest',
    DeleteOngoingTest = 'deleteOngoingTest',
    DeleteUpcomingNormTest = 'deleteUpcomingNormTest'
}
